import type { FC } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoIosClose } from "react-icons/io";
import { TbLock } from "react-icons/tb";
import { MoonLoader } from "react-spinners";
import { useModalCambiarContrasena } from "./modalCambiarContrasenaHooks";
import type { ModalCambiarContrasenaProps } from "./types";

export const ModalCambiarContrasena: FC<ModalCambiarContrasenaProps> = (
  props
) => {
  const {
    currentPassword,
    error,
    handleChangePassword,
    handleClose,
    handlePasswordFieldChange,
    isButtonPassword,
    isButtonPasswordNew,
    isSubmiting,
    newPassword,
    newPasswordVerify,
    togglePasswordVisibility,
  } = useModalCambiarContrasena(props);

  return (
    <div className="w-full min-h-screen h-screen z-10 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative flex flex-col items-center max-h-[90%] overflow-y-auto">
        <IoIosClose
          className="absolute right-0 top-0 cursor-pointer"
          size={40}
          onClick={handleClose}
        />
        <h2 className="text-center text-xl font-semibold">
          Cambiar Contrasena
        </h2>
        <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-1">
          <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center border-gray-400 rounded-l-md border-r">
            <TbLock size={24} />
          </div>
          <input
            type={isButtonPassword ? "password" : "text"}
            className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
            placeholder="Contrasena Actual"
            value={currentPassword}
            onChange={handlePasswordFieldChange("currentPassword")}
          />
          <div className="h-full w-[40px] bg-white rounded-md flex items-center justify-center">
            {isButtonPassword ? (
              <AiOutlineEye
                onClick={() => togglePasswordVisibility("current")}
                className="text-gray-500"
                size={24}
              />
            ) : (
              <AiOutlineEyeInvisible
                onClick={() => togglePasswordVisibility("current")}
                className="text-gray-500"
                size={24}
              />
            )}
          </div>
        </div>

        <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-2">
          <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center border-gray-400 rounded-l-md border-r">
            <TbLock size={24} />
          </div>
          <input
            type={isButtonPasswordNew ? "password" : "text"}
            className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
            placeholder="Nueva Contrasena"
            value={newPassword}
            onChange={handlePasswordFieldChange("newPassword")}
          />
          <div className="h-full w-[40px] bg-white rounded-md flex items-center justify-center">
            {isButtonPasswordNew ? (
              <AiOutlineEye
                onClick={() => togglePasswordVisibility("new")}
                className="text-gray-500"
                size={24}
              />
            ) : (
              <AiOutlineEyeInvisible
                onClick={() => togglePasswordVisibility("new")}
                className="text-gray-500"
                size={24}
              />
            )}
          </div>
        </div>

        <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-2">
          <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center border-gray-400 rounded-l-md border-r">
            <TbLock size={24} />
          </div>
          <input
            type={isButtonPasswordNew ? "password" : "text"}
            className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
            placeholder="Verificar Nueva Contrasena"
            value={newPasswordVerify}
            onChange={handlePasswordFieldChange("newPasswordVerify")}
          />
          <div className="h-full w-[40px] bg-white rounded-md flex items-center justify-center">
            {isButtonPasswordNew ? (
              <AiOutlineEye
                onClick={() => togglePasswordVisibility("new")}
                className="text-gray-500"
                size={24}
              />
            ) : (
              <AiOutlineEyeInvisible
                onClick={() => togglePasswordVisibility("new")}
                className="text-gray-500"
                size={24}
              />
            )}
          </div>
        </div>

        {error ? <p className="text-red-500">{error}</p> : null}
        <button
          type="button"
          className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px] font-semibold"
          onClick={handleChangePassword}
        >
          {isSubmiting ? <MoonLoader size={20} color="#ffffff" /> : "Cambiar"}
        </button>
      </div>
    </div>
  );
};
